// snake_case to UPPER CASE WITH SPACES
export const mapSnakeCaseToUpperCaseWithSpaces = (snake_case: string): string =>
  snake_case.toUpperCase().replace("_", " ");

// Uppper Case With Spaces to snake_case
export const mapUpperCaseWithSpacesToSnakeCase = (
  upperCaseWithSpaces: string
): string => upperCaseWithSpaces.toLowerCase().replace(" ", "_");

// snake_case to Capital Case With Spaces
export const mapSnakeCaseToCapitalCaseWithSpaces = (
  snake_case: string
): string => {
  let splitStr = snake_case.replace("_", " ").split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
};
